<!-- =========================================================================================
  File Name: DashboardDemo.vue
  Description: Dashboard Demo
========================================================================================== -->

<template>
  <div id="dashboard-analytics" class="pt-55-custom">
    <div class="vx-row">
      <!-- CARD 1: Create Contract -->
      <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="新規作成の場合">
          <vs-button
            type="border"
            icon-pack="feather"
            icon="icon-chevrons-right"
            icon-after
            class="shadow-md w-full lg:mt-0 mt-4"
            @click="onGoToContractSelection"
            >新規作成の場合</vs-button
          >
        </vx-card>
      </div>

      <!-- CARD 2: Edit Contract -->
      <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="編集の場合">
          <vs-button
            type="border"
            icon-pack="feather"
            icon="icon-chevrons-right"
            icon-after
            class="shadow-md w-full lg:mt-0 mt-4"
            @click="onGoToEditContractSelection"
            >編集の場合</vs-button
          >
        </vx-card>
      </div>

      <!-- CARD 3: Duplicate Contract -->
      <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="流用作成の場合">
          <vs-button
            type="border"
            icon-pack="feather"
            icon="icon-chevrons-right"
            icon-after
            class="shadow-md w-full lg:mt-0 mt-4"
            @click="$router.push({ name: 'contract-history' })"
            >流用作成の場合</vs-button
          >
        </vx-card>
      </div>

    <!-- TODO CARD 4: Download Oboegaki -->
    <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="覚書・委任状">
            <vs-button type="border"
              icon-pack="feather"
              icon="icon-chevrons-right"
              icon-after
              class="shadow-md w-full lg:mt-0 mt-4"
              @click="$router.push({name: 'oboegaki'})">覚書・委任状</vs-button>
        </vx-card>
    </div>

    <!-- CARD 5: TOPIC -->
    <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="TOPIC">
            <vs-button type="border"
              icon-pack="feather"
              icon="icon-chevrons-right"
              icon-after
              class="shadow-md w-full lg:mt-0 mt-4"
              @click="$router.push({name: 'topic'})">TOPIC</vs-button>
        </vx-card>
    </div>

    <!-- TODO CARD 6 CRUD Category -->
    <div v-if="isShowDocumentUpload" class="vx-col w-full lg:w-1/3 mb-base">
      <vx-card title="覚書・委任状設定">
        <vs-button
          type="border"
          icon-pack="feather"
          icon="icon-chevrons-right"
          icon-after
          class="shadow-md w-full lg:mt-0 mt-4"
          @click="$router.push({ name: 'category_subcategory_kanri' })"
          >覚書・委任状設定</vs-button
        >
      </vx-card>
    </div>

    <!-- CARD 7 Master Bunshou -->
    <div v-if="isShowDocumentUpload" class="vx-col w-full lg:w-1/3 mb-base">
      <vx-card title="テンプレート設定">
        <vs-button
          type="border"
          icon-pack="feather"
          icon="icon-chevrons-right"
          icon-after
          class="shadow-md w-full lg:mt-0 mt-4"
          @click="$router.push({ name: 'master-template' })"
          >テンプレート設定</vs-button
        >
      </vx-card>
    </div>
    <!-- CARD 8 Takkengyosha Address -->
    <div v-if="isShowDocumentUpload" class="vx-col w-full lg:w-1/3 mb-base">
      <vx-card title="テンプレート設定">
        <vs-button
          type="border"
          icon-pack="feather"
          icon="icon-chevrons-right"
          icon-after
          class="shadow-md w-full lg:mt-0 mt-4"
          @click="$router.push({ name: 'agent-address' })"
          >宅建業者アドレス</vs-button
        >
        <!-- $router.push({ name: 'agent-address' }) -->
      </vx-card>
    </div>
  </div>
</div>
</template>

<script>
import base64Url from 'base64-url'
import {
  GET_ROLE
} from '@/store/modules/keiyaku/actions'

export default {
  name: 'Dashboard',
  data() {
    return {
      ctrlFlag: false,
      role: 0
    }
  },
  computed: {
    isShowDocumentUpload() {
      return this.role === 0 || this.role === 2
    }
  },
  mounted() {
    this.$store.dispatch(GET_ROLE).then((response) => {
      const { data } = response
      this.role = data
    })
    // RESET
    document.addEventListener('keydown', ($event) => {
      if ($event.key === 'Control') {
        this.ctrlFlag = true
      }

      if (this.ctrlFlag && $event.key === 'a') {
        $event.preventDefault()
        return false
      }
    })

    document.addEventListener('keyup', ($event) => {
      if ($event.key === 'Control') {
        this.ctrlFlag = false
      }
    })
  },
  methods: {
    onGoToContractSelection() {
      this.$router.push({ name: 'contract-selection' })
    },
    onGoToEditContractSelection() {
      const documentId = base64Url.encode('MusubellDocumentType:1')
      this.$router.push(
        `/office/ZG9jdW1lbnRJZDo5OQ/item/ZG9jdW1lbnRJZDo5OQ/document/${documentId}/edit_baikei`
      )
    }
  }
}
</script>

<style lang="scss">
.pt-55-custom {
  padding-top: 5.5rem;
}
</style>
